<template>
    <div>
        <div class="alarmContact-title">
            <div>{{ $t('alarm_contact.alarmContact') }}</div>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('alarm_contact.contact')">
                    <div class="alarmContact-top">
                        <alarm-contact-search></alarm-contact-search>
                    </div>
                    <table-alarm-contact></table-alarm-contact>
                </TabPane>
                <TabPane :label="$t('alarm_contact.contactGroup')">
                    <div class="alarmContact-top">
                        <alarm-contact-group-search></alarm-contact-group-search>
                    </div>
                    <table-alarm-contact-group></table-alarm-contact-group>
                </TabPane>
                <TabPane :label="$t('alarm_contact.enterpriseWechatRobot')">
                    <div class="alarmContact-top">
                        <enterprise-wechat-robot-search></enterprise-wechat-robot-search>
                    </div>
                    <table-enterprise-wechat-robot></table-enterprise-wechat-robot>
                </TabPane>
            </Tabs>
        </template>

    </div>
</template>

<script>
    import AlarmContactSearch from '../alarm_contact/alarm_contact/AlarmContactSearch'
    import TableAlarmContact from '../alarm_contact/alarm_contact/TableAlarmContact'
    import AlarmContactGroupSearch from '../alarm_contact/alarm_contact_group/AlarmContactGroupSearch'
    import TableAlarmContactGroup from '../alarm_contact/alarm_contact_group/TableAlarmContactGroup'
    import EnterpriseWechatRobotSearch from '../alarm_contact/enterprise_wechat_robot/EnterpriseWechatRobotSearch'
    import TableEnterpriseWechatRobot from '../alarm_contact/enterprise_wechat_robot/TableEnterpriseWechatRobot'

    export default {
        name: 'AlarmContact',
        components: {
            AlarmContactSearch,
            TableAlarmContact,
            AlarmContactGroupSearch,
            TableAlarmContactGroup,
            EnterpriseWechatRobotSearch,
            TableEnterpriseWechatRobot
        }
    }
</script>

<style scoped>
    .alarmContact-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .alarmContact-title>div:nth-child(1)
    {
        float:left;
    }
    .alarmContact-top
    {
        width: 100%;
        height: 32px;
        margin-bottom: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/alarm_contact/AlarmContact.vue